export default __webpack_public_path__ + "0a51c275735ec1b07549a6115a9ba4f5.png";